import styled from '@emotion/styled'
import { Container, Grid } from '@mui/material'
import React from 'react'
import { Heading } from '../../../../Components/Heading'
import { SubHeading } from '../../../../Components/SubHeading'
import { Text } from '../../../../Components/Text'
import tokenomicsImg from '../../../../images/tokenomics.png'

const TokenomicsImg = styled.img`
    width: 100%;
    max-width: 400px;
    height: auto;
`

export const Tokenomics = () => {
  return (
    <Container id="tokenomics" maxWidth="xl" className='py-5'>
        <Grid container justifyContent='center' alignItems='center'>
            <Grid xs={12} md={6} />
            <Grid xs={12} md={6}>
                <Heading mb="10px">Tokenomics</Heading>
                <Text>Hyper-deflationary tokenomics to grow $PPF exponentially!</Text>
            </Grid>
            <Grid xs={12} sm={6} className="text-center p-4">
                <TokenomicsImg src={tokenomicsImg} />
            </Grid>
            <Grid xs={12} sm={6} className="text-center">
                <div className='d-inline-block text-left'>
                    <h2 className='text-light'>Transactionomics</h2>
                    <SubHeading mb="10px">Total Buy/Sell Tax: 12%</SubHeading>
                    <Text mb="5px">6% $Pulse rewards</Text>
                    <Text mb="5px">2% Liquidity generation</Text>
                    <Text mb="5px">2% Maintenance wallet</Text>
                    <Text mb="5px">2% Token buyback & burn</Text>
                    <Text mb="5px">(All rewards are automatically distributed)</Text>
                </div>
            </Grid>
        </Grid>
    </Container>
  )
}
